export const parseProductData = (data: any) => {
  if (!data) return []

  return {
    id: data.id,
    name: data.name || '-',
    sku: data.sku || '-',
    status: data.is_visible === true ? 'active' : 'inactive',
    createdAt: data.created_at || '-',
    updatedAt: data.updated_at || '-',
    category: data.category_names?.length > 1 ? data.category_names?.join(', ') : data.category_names?.[0] || '-',
    brand: data.brand || '-',
  }
}

export const parseBadgeData = (data: any) => {
  if (!data) return null

  return {
    id: data.id,
    badgeName: data.badge_name,
    tagLabel: data.tag_label,
    bgColor: data.bg_color,
    fontColor: data.font_color,
    productListing: data.product_listing || false,
    productDetails: data.product_details || false,
    brandIds: data.brand_ids || [],
    categoryIds: data.category_ids || [],
    individual_products: data.individual_products || [],
    createdAt: data.created_at,
    updatedAt: data.modified_at,
  }
}

// Parse products dropdown API response
export const parseProductsDropdown = (data: any[]) => {
  if (!data) return []
  return data.map((item) => ({
    id: item.product_id,
    sku: item.sku,
    name: item.product_name,
    status: item.is_visible === true ? 'active' : 'inactive',
  }))
}
